import { render } from "./InstructionsModal.vue?vue&type=template&id=5f1fb09a&scoped=true"
import script from "./InstructionsModal.vue?vue&type=script&lang=js"
export * from "./InstructionsModal.vue?vue&type=script&lang=js"

import "./InstructionsModal.vue?vue&type=style&index=0&id=5f1fb09a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1fb09a"]])

export default __exports__